export default {
  namespaced: true,
  state: {
    banks: {},
  },
  mutations: {
    setBank(state, payload) {
      state.banks = payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bank.js